export function getChangePasswordSuccessReducer(state, action) {
	return {
		...state,
		isLoading: action.isLoading,
		isDisconnected: false,
		error: null,
		refreshCurrentPageStatus: true,
	};
}
